import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { FastCleanerModalProps } from './FastCleanerModal.types';

export const renderFastCleanModal = (data?: FastCleanerModalProps) => {
    openPopupHelper({
        popupName: popupNames.FAST_CLEANER_MODAL,
        data,
        onClose: data?.onClose,
    });
};

export const closeFastCleanerModal = () => {
    closePopupHelper(popupNames.FAST_CLEANER_MODAL);
};
